module.exports = __webpack_public_path__ + "img/西瓜7.7f734340.png";